import { spots, baseMapSpots } from "../data/oceanGuidePlaces.mjs";
import { img } from "./cloudinaryImage.mjs";

export const OCEAN_SITE_URL = "https://premium-tour-miyako.com";
export const placeCollections = {
  spots: {
    title: "宮古島のビーチ・観光スポット",
    description: "宮古島・伊良部島・下地島・来間島・池間島のビーチや景色を楽しむスポットを紹介。場所の特徴、設備、駐車場を確認し、その日の海況と合わせて行き先を探せます。",
    eyebrow: "BEACH & SPOTS",
  },
  restaurants: {
    title: "宮古島の飲食店・カフェ",
    description: "宮古島の夜ご飯、ランチ、カフェ、締めご飯のお店を紹介。ジャンル、営業時間、定休日、予算、アクセスを確認できます。",
    eyebrow: "FOOD & CAFE",
  },
};

// Permanent URLs: keep these slugs unchanged when display names are edited.
const spotSlugs = {
  "新城海岸": "aragusuku-beach",
  "与那覇前浜ビーチ": "yonaha-maehama-beach",
  "長間浜": "nagamahama",
  "サンセットビーチ": "sunset-beach",
  "砂山ビーチ": "sunayama-beach",
  "伊良部大橋": "irabu-bridge",
  "17END": "17end",
  "ムスヌン浜": "musunun-beach",
  "池間島北側": "ikema-north",
  "シギラビーチ": "shigira-beach",
  "ワイワイビーチ": "waiwai-beach",
  "サバウツガー": "sabautsuga",
  "中の島海岸": "nakanoshima-beach",
  "吉野海岸": "yoshino-beach",
  "イキヅービーチ": "ikizu-beach",
  "フナクスビーチ": "funakusu-beach",
  "インギャーマリンガーデン": "imgya-marine-garden",
  "東平安名崎": "higashi-hennazaki",
  "渡口の浜": "toguchi-beach",
  "比嘉ロードパーク": "higa-road-park",
  "白鳥岬": "shiratori-cape",
  "通り池": "toriike",
  "パチャビーチ": "pacha-beach",
  "博愛漁港": "hakuai-port",
  "赤浜漁港": "akahama-port",
  "帯岩": "obiiwa",
  "高野漁港": "takano-port",
  "西平安名崎": "nishi-hennazaki",
  "川満漁港": "kawamitsu-port",
};
const restaurantSlugs = {
  "Blue Turtle": "blue-turtle",
  "OHAMAテラス": "ohama-terrace",
  "HARRY'S Shrimp Truck": "harrys-shrimp-truck",
  "Pani Pani": "pani-pani",
  "ブルータートルファーム マンゴーカフェ": "blue-turtle-farm",
  "島cafeとぅんからや": "tunkaraya",
  "Seahorse Club Cafe": "seahorse-club-cafe",
  "gelato cafe Ninufa": "ninufa",
  "農家れすとらん 楽園の果実": "rakuen-no-kajitsu",
  "島茶屋ヤッカヤッカ": "yakka-yakka",
  "DOUG’S BURGER": "dougs-burger",
  "ブルーシール 宮古島パイナガマ店": "blue-seal-painagama",
  "ユートピアファーム宮古島": "utopia-farm",
  "SHISA'S CAFE & BBQ": "shisas-cafe",
  "島おでん たから": "shima-oden-takara",
  "美ら島": "churashima",
  "居酒家 でいりぐち": "deiriguchi",
  "宮古創作料理 風まかせ": "kazemakase",
  "宮古炉端 素燻": "sukun",
  "地鶏と島野菜 粋蓮": "suiren",
  "居酒屋 南樂": "nanraku",
  "ツマンデ呑める みやこパーラー ハイサイ!": "haisai",
  "Pork&Fish Dining HULAR": "hular",
  "わとわ 宮古島店": "watowa",
  "にんにく焼肉 プルシン宮古島店": "purushin",
  "ホルモン人 宮古島本店": "horumonjin",
  "宮古酒場イツモノトコ。": "itsumonotoko",
  "北琉笑店 いころ": "ikoro",
  "海鮮 炭火 ABURI": "aburi",
  "うまりずま": "umarizuma",
  "宮古牛の焼肉 喜八": "kihachi",
  "沖縄やんばるアグーしゃぶしゃぶ 嘉福": "kafuku",
  "すばや 大和": "subaya-yamato",
  "麺や 大和": "menya-yamato",
  "魚天": "uoten",
  "MARUGO肉バル": "marugo",
  "ピッツァバル": "pizza-bar",
  "貝出汁〆そば名月": "meigetsu",
};

export const placeCategoryLabels = {
  snorkel: "シュノーケル", beach: "ビーチ", sunset: "サンセット", stars: "星空",
  cafe: "カフェ", lunch: "ランチ", dinner: "夜ご飯", lateNightMeal: "締めご飯",
};

const spotArea = (name) => {
  if (/17END|中の島|通り池|帯岩/.test(name)) return "下地島";
  if (/伊良部|サバウツガー|渡口|白鳥/.test(name)) return "伊良部島";
  if (/長間浜|ムスヌン浜|パチャ/.test(name)) return "来間島";
  if (/池間|フナクス|イキヅー/.test(name)) return "池間島";
  return "宮古島";
};
const makePlace = (source, collection, slug) => ({
  ...source,
  collection,
  slug,
  path: `/ocean-guide/${collection}/${slug}`,
  area: source.area || spotArea(source.name),
  description: source.description || source.detail ||
    `${source.area || "宮古島"}エリアの${source.genre || "スポット"}。営業時間や予算、場所を確認して、お出かけの計画にお役立てください。`,
  image: source.image || source.images?.find((value) => typeof value === "string" && !value.includes("instagram.com")) || "",
  categories: (source.categories || []).filter((key) => placeCategoryLabels[key]),
});

export const oceanPlaces = [
  ...spots.filter((spot) => spotSlugs[spot.name]).map((spot) =>
    makePlace({ ...baseMapSpots.find((item) => item.name === spot.name), ...spot }, "spots", spotSlugs[spot.name])),
  ...baseMapSpots.filter((spot) => restaurantSlugs[spot.name]).map((spot) =>
    makePlace(spot, "restaurants", restaurantSlugs[spot.name])),
];
export const findOceanPlace = (collection, slug) =>
  oceanPlaces.find((place) => place.collection === collection && place.slug === slug);
export const getOceanPlacePath = (name) => oceanPlaces.find((place) => place.name === name)?.path;
export const isOceanPlacePath = (path) => /^\/ocean-guide\/(spots|restaurants)(?:\/|$)/.test(path);
export const oceanPlacePaths = [
  ...Object.keys(placeCollections).map((key) => `/ocean-guide/${key}`),
  ...oceanPlaces.map((place) => place.path),
];
export const getPlaceMapUrl = (place) => place.mapUrl ||
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(place.address ? `${place.name} ${place.address}` : place.mapQuery || `${place.name} 宮古島`)}`;

export const getPlaceFacts = (place) => (place.collection === "restaurants" ? [
  ["ジャンル", place.genre],
  ["エリア", place.area],
  ["営業時間", place.hours || "要確認"],
  ["定休日", place.closed || "要確認"],
  ["1人あたりの予算目安", place.priceRange?.replace(/^1人あたり\s*/, "") || "要確認"],
  ["電話番号", place.phone],
  ["住所", place.address],
  ["来店の目安", place.crowd],
  // Dinner pages follow the Ocean Guide setting: do not list parking.
  ...(!place.categories.includes("dinner") ? [["駐車場", place.parking]] : []),
] : [
  ["エリア", place.area],
  ["楽しみ方", place.categories.map((key) => placeCategoryLabels[key]).join(" / ")],
  ["駐車場", place.parking || "要確認"],
  ["トイレ・シャワー", place.facilities || "要確認"],
]).filter(([, value]) => value);

export const getPlaceFaqs = (place) => {
  if (place.collection === "restaurants") return [
    [`${place.name}の営業時間・定休日は？`, `掲載している営業時間は${place.hours || "要確認"}、定休日は${place.closed || "要確認"}です。臨時休業や変更は来店前に店舗へご確認ください。`],
    ...(place.priceRange ? [[`${place.name}の予算は？`, `1人あたりの目安は${place.priceRange.replace(/^1人あたり\s*/, "")}です。注文内容やコースによって変わります。`]] : []),
    [`${place.name}はどこにありますか？`, place.address ? `${place.address}にあります。アクセスはGoogleマップで確認できます。` : `${place.area}エリアのお店です。詳しい位置はGoogleマップで確認できます。`],
  ];
  return [
    [`${place.name}はどこにありますか？`, `${place.area}のスポットです。詳しい位置やアクセスはこのページのGoogleマップから確認できます。`],
    ...(place.parking ? [[`${place.name}に駐車場はありますか？`, place.parking]] : []),
    ...(place.facilities ? [[`${place.name}の設備は？`, place.facilities]] : []),
    [`${place.name}の今日の海況はどこで確認できますか？`, "Ocean Guideのマップで場所ごとの風や波の影響を確認できます。このページはスポットの基本情報です。現地の状況や立入制限も確認してください。"],
  ];
};
export const getRelatedPlaces = (place) => oceanPlaces
  .filter((candidate) => candidate.collection === place.collection && candidate.slug !== place.slug)
  .map((candidate) => ({ candidate, score: (candidate.area === place.area ? 3 : 0) + candidate.categories.filter((key) => place.categories.includes(key)).length }))
  .sort((a, b) => b.score - a.score)
  .slice(0, 3).map(({ candidate }) => candidate);

export const getPlaceGuideLinks = (place) => place.collection === "restaurants" ? [
  ["/blog/miyakojima-night-dinner-guide", "雰囲気から夜ご飯を探す"],
  ["/blog/cafe-by-area", "エリア別のカフェガイド"],
  ["/ocean-guide/rainy-day", "雨の日の過ごし方"],
] : [
  ...(place.categories.includes("snorkel") ? [["/ocean-guide/snorkeling-today", "今日のシュノーケル情報"]] : []),
  ...(place.categories.includes("sunset") ? [["/ocean-guide/sunset-today", "今日のサンセット情報"]] : []),
  ...(place.categories.includes("stars") ? [["/ocean-guide/stargazing-tonight", "今夜の星空情報"]] : []),
  ["/ocean-guide/tomorrow-weather", "明日の天気・海況"],
  ["/ocean-guide/windy-day-beaches", "風の日のビーチ選び"],
];

export const getOceanPlaceSeo = (pathname) => {
  const [, collection, slug] = /^\/ocean-guide\/(spots|restaurants)(?:\/([^/]+))?\/?$/.exec(pathname) || [];
  if (!collection) return null;
  const place = slug ? findOceanPlace(collection, slug) : null;
  if (slug && !place) return {
    title: "ページが見つかりません | Ocean Guide Miyakojima",
    description: "スポット・飲食店の一覧からお探しください。",
    singleLanguage: true, noindex: true, locale: "ja_JP",
  };
  const info = placeCollections[collection];
  const title = place
    ? `${place.name}｜${collection === "restaurants" ? "宮古島の営業時間・メニュー・予算" : "宮古島の見どころ・アクセス・設備"}`
    : `${info.title}一覧 | Ocean Guide Miyakojima`;
  const description = place
    ? `${place.name}の${collection === "restaurants" ? "営業時間・定休日・予算・アクセスをご紹介。" : "特徴・設備・駐車場・アクセスをご紹介。"}${place.description}`.slice(0, 160)
    : info.description;
  const image = place?.image
    ? img(place.image, { width: 1200, height: 630, format: "jpg" })
    : `${OCEAN_SITE_URL}/icons/ocean-guide-512.png`;
  const canonical = `${OCEAN_SITE_URL}${place?.path || `/ocean-guide/${collection}`}`;
  const breadcrumbs = [
    ["Ocean Guide", "/ocean-guide"],
    [info.title, `/ocean-guide/${collection}`],
    ...(place ? [[place.name, place.path]] : []),
  ];
  const entity = place ? {
    "@type": collection === "restaurants" ? "Restaurant" : "TouristAttraction",
    "@id": `${canonical}#place`,
    name: place.name, description: place.description, url: canonical,
    ...(place.image ? { image: place.image } : {}),
    ...(place.address ? { address: { "@type": "PostalAddress", streetAddress: place.address, addressLocality: "宮古島市", addressRegion: "沖縄県", addressCountry: "JP" } } : {}),
    ...(place.phone ? { telephone: place.phone } : {}),
    ...(place.priceRange ? { priceRange: place.priceRange.replace(/^1人あたり\s*/, "") } : {}),
    ...(place.genre ? { servesCuisine: place.genre.split(/\s*\/\s*/) } : {}),
    hasMap: getPlaceMapUrl(place),
    // Coordinates for some restaurants are approximate, so omit them here.
    ...(collection === "spots" && place.location ? { geo: { "@type": "GeoCoordinates", latitude: place.location.lat, longitude: place.location.lng } } : {}),
  } : {
    "@type": "ItemList", "@id": `${canonical}#places`,
    itemListElement: oceanPlaces.filter((item) => item.collection === collection).map((item, index) => ({
      "@type": "ListItem", position: index + 1, name: item.name, url: `${OCEAN_SITE_URL}${item.path}`,
    })),
  };
  return {
    title, description, image, singleLanguage: true, locale: "ja_JP",
    keywords: ["宮古島", place?.name || info.title, ...(place?.categories.map((key) => placeCategoryLabels[key]) || [])],
    structuredData: {
      "@context": "https://schema.org",
      "@graph": [
        { "@type": place ? "WebPage" : "CollectionPage", "@id": `${canonical}#webpage`, name: title, description, url: canonical, inLanguage: "ja", mainEntity: { "@id": entity["@id"] } },
        entity,
        { "@type": "BreadcrumbList", itemListElement: breadcrumbs.map(([name, path], index) => ({ "@type": "ListItem", position: index + 1, name, item: `${OCEAN_SITE_URL}${path}` })) },
      ],
    },
  };
};
